import React from 'react';
import { getLazyLinkToImage } from '../../../utils/getLazyLinkToImage';
import { getImageSizes } from './Items.component';
import { dlDispatchAmplEvent } from '../../../events/dl.dispatchAmplEvent';
export const PromoCard = ({ order, imageURL, link, perRow }) => {
    const imageSizes = getImageSizes(perRow);
    return (React.createElement("li", { style: { order } },
        React.createElement("a", { className: 'image-wrapper d:block w:100p h:100p ov:h bdrs:2', href: link, onClick: () => {
                dlDispatchAmplEvent('Upload photo promo');
            } },
            React.createElement("img", { src: imageURL, srcSet: `${['180', '360', '540', '720', '900', '1080', '1200'].reduce((str, curr, i) => {
                    return `${str}${i === 0 ? '' : ','} ${getLazyLinkToImage(imageURL).replace('{width}', curr)} ${curr}w`;
                }, '')}`, sizes: imageSizes, className: 'h:100p w:auto skeleton', loading: 'lazy', alt: 'Custom Canvas Prints Wall Art' }))));
};
